// Three tiers, matching KitchenTicket.elapsed_label exactly: seconds only
// matter inside the first hour (the SLA window itself), minutes past that,
// and past a day even minutes are more noise than signal for something read
// at a glance across a kitchen or a runner board.
//
// Shared by kitchen_timer_controller and service_card_timer_controller so the
// two surfaces can't drift out of format sync with each other the way they
// did before this was extracted — one used this tiering, the other its own
// h:mm:ss, and the mismatch didn't show up until you sat and watched a card.
export function formatElapsed(seconds) {
  const pad = (n) => n.toString().padStart(2, "0")

  if (seconds < 3600) {
    return `${Math.floor(seconds / 60)}m ${pad(seconds % 60)}s`
  }
  if (seconds < 86400) {
    return `${Math.floor(seconds / 3600)}h ${pad(Math.floor((seconds % 3600) / 60))}m`
  }
  return `${Math.floor(seconds / 86400)}d ${pad(Math.floor((seconds % 86400) / 3600))}h`
}
